<template>
  <section class="nx-about nx-grid-bg" id="about">
    <!-- 公司介绍部分 -->
    <div class="nx-about-intro">
      <div class="nx-about-container">
        <!-- 标题区 -->
        <div class="nx-about-header nx-animate-on-scroll">
          <p class="nx-about-subtitle">{{ config?.about?.subtitle }}</p>
          <h2 class="nx-about-title">{{ config?.about?.title }}</h2>
        </div>

        <!-- 内容卡片 - 四个独立区块 -->
        <div class="nx-about-content-grid nx-animate-on-scroll">
          <!-- 第1个卡片 - 图片 -->
          <div
            class="nx-about-section-card nx-about-section-1 nx-animate-on-scroll nx-image-card"
            :style="{ animationDelay: '0s',padding:'0' }"
          >
            <img
              :src="config?.about?.cardImage1 || '/img/products/简介8.png'"
              alt="公司优势"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>

          <!-- 第2个卡片 - 文字 -->
          <div
            v-for="(section, index) in contentSections.slice(0, 1)"
            :key="'section-' + index"
            class="nx-about-section-card nx-about-section-2 nx-animate-on-scroll"
            :style="{ animationDelay: '0.15s' }"
          >
            <div class="nx-about-section-content">
              <p class="nx-about-section-text">{{ section }}</p>
            </div>
          </div>

          <!-- 第3个卡片 - 图片 -->
          <div
            class="nx-about-section-card nx-about-section-3 nx-animate-on-scroll nx-image-card"
            :style="{ animationDelay: '0.3s',padding:'0' }"
          >
            <img
              :src="config?.about?.cardImage2 || '/img/products/简介5.png'"
              alt="服务优势"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>

          <!-- 第4个卡片 - 文字 -->
          <div
            v-for="(section, index) in contentSections.slice(1, 2)"
            :key="'section-text-' + index"
            class="nx-about-section-card nx-about-section-4 nx-animate-on-scroll"
            :style="{ animationDelay: '0.45s' }"
          >
            <div class="nx-about-section-content">
              <p class="nx-about-section-text">{{ section }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 为什么选择文信部分 -->
    <div class="nx-why-section">
      <div class="nx-why-container">
        <div class="nx-why-header nx-animate-on-scroll">
          <p class="nx-why-subtitle">{{ config?.whyChoose?.subtitle }}</p>
          <h2 class="nx-why-title">{{ config?.whyChoose?.title }}</h2>
          <p class="nx-why-desc">{{ config?.whyChoose?.description }}</p>
        </div>

        <div class="nx-why-content">
          <div class="nx-why-column nx-why-left">
            <div
              v-for="(item, index) in config?.whyChoose?.left || []"
              :key="'left-' + index"
              class="nx-why-item nx-animate-on-scroll"
              :style="{ animationDelay: index * 0.2 + 's' }"
            >
              <h4 class="nx-why-item-title">{{ item.title }}</h4>
              <p
                class="nx-why-text"
                v-html="item.content.replace(/\n/g, '<br />')"
              ></p>
            </div>
          </div>

          <div class="nx-why-column nx-why-right">
            <div
              v-for="(item, index) in config?.whyChoose?.right || []"
              :key="'right-' + index"
              class="nx-why-item nx-animate-on-scroll"
              :style="{ animationDelay: index * 0.2 + 0.1 + 's' }"
            >
              <h4 class="nx-why-item-title">{{ item.title }}</h4>
              <p
                class="nx-why-text"
                v-html="item.content.replace(/\n/g, '<br />')"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司动态部分 -->
    <div class="nx-news-section">
      <div class="nx-news-container">
        <div class="nx-news-header nx-animate-on-scroll">
          <p class="nx-news-subtitle">{{ config?.news?.subtitle }}</p>
          <h2 class="nx-news-title">{{ config?.news?.title }}</h2>
          <p class="nx-news-desc">{{ config?.news?.description }}</p>
        </div>

        <!-- 查看更多按钮 -->
        <div class="nx-news-more">
          <a href="javascript:void(0)" class="nx-news-more-btn" @click="goToNewsCenter">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 17L18 12L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 17L11 12L6 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <div class="nx-news-content">
          <div
            v-for="(item, index) in (config?.news?.items || []).slice(0, 3)"
            :key="'news-' + index"
            class="nx-news-item nx-animate-on-scroll"
            :style="{ animationDelay: index * 0.15 + 's' }"
            @click="goToNewsDetail(item.id)"
          >
            <div class="nx-news-date">
              <span class="nx-news-year">{{ item.year }}</span>
              <span class="nx-news-md">{{ item.month }}{{ item.day }}</span>
            </div>
            <div class="nx-news-info">
              <h4 class="nx-news-item-title">{{ item.title }}</h4>
              <p class="nx-news-text">{{ item.description }}</p>
            </div>
            <div class="nx-news-arrow">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NxAbout",
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    formattedContent() {
      return this.config?.about?.content || "";
    },
    contentSections() {
      const content = this.config?.about?.content || "";
      // 按换行符分割，并过滤掉空行
      return content.split("\n").filter((section) => section.trim());
    },
  },
  mounted() {
    this.initScrollAnimation();
  },
  beforeUnmount() {
    this.cleanupScrollAnimation();
  },
  methods: {
    goToNewsDetail(newsId) {
      window.open(`/news-detail?id=${newsId}`, "_blank");
    },
    goToNewsCenter() {
      const url = window.location.origin + '/news-center';
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    initScrollAnimation() {
      // 使用 Intersection Observer 实现滚动入场动画
      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.15,
      };

      this.scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("nx-visible");
            // 动画完成后停止观察
            this.scrollObserver.unobserve(entry.target);
          }
        });
      }, observerOptions);

      // 观察所有需要动画的元素
      this.$nextTick(() => {
        const animatedElements = this.$el.querySelectorAll(
          ".nx-animate-on-scroll",
        );
        animatedElements.forEach((el) => {
          this.scrollObserver.observe(el);
        });
      });
    },
    cleanupScrollAnimation() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
      }
    },
  },
};
</script>

<style scoped>
/* 整体容器 - 浅色清新版 */
.nx-about {
  position: relative;
  background: #ffffff;
  overflow: hidden;
  will-change: transform;
}

.nx-about::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 700px;
  background: radial-gradient(
      ellipse at top,
      rgba(59, 130, 246, 0.05) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse at 80% 20%,
      rgba(139, 92, 246, 0.04) 0%,
      transparent 50%
    );
  pointer-events: none;
  opacity: 0.8;
  transform: translateY(0);
  will-change: opacity, transform;
}

.nx-about::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      90deg,
      rgba(21, 101, 192, 0.015) 1px,
      transparent 1px
    ),
    linear-gradient(rgba(21, 101, 192, 0.015) 1px, transparent 1px);
  background-size: 80px 80px;
  opacity: 0.3;
  pointer-events: none;
}

.nx-about::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      90deg,
      rgba(21, 101, 192, 0.015) 1px,
      transparent 1px
    ),
    linear-gradient(rgba(21, 101, 192, 0.015) 1px, transparent 1px);
  background-size: 80px 80px;
  opacity: 0.3;
  pointer-events: none;
}

/* 公司介绍部分 */
.nx-about-intro {
  position: relative;
  padding: 80px 0 80px 0;
  z-index: 1;
}

.nx-about-container {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  padding: 0;
}

.nx-about-header {
  text-align: center;
  margin-bottom: 0;
  position: relative;
  background: #ffffff;
  padding: 60px 20px 40px;
  margin-top: -80px;
}

/* 标题区域深色背景与首页融合 */
.nx-about-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(66, 165, 245, 0.2) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.nx-about-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0.4rem;
  text-shadow: none;
  position: relative;
  z-index: 1;
}

.nx-about-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: none;
  position: relative;
  display: inline-block;
  z-index: 1;
}

/* 标题底部光效 */
.nx-about-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
  animation: titleGlow 2s ease-in-out infinite;
}

.nx-about-content-wrapper {
  display: flex;
  justify-content: center;
}

.nx-about-content-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 420px;
  gap: 0;
  width: 100%;
  border-radius: 0;
  overflow: hidden;
}

.nx-about-section-card {
  position: relative;
  padding: 80px 35px 45px 35px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  height: 100%;
  overflow: hidden;
  perspective: 1000px;
  transform-style: preserve-3d;
}

/* 科技感扫描线效果 */
.nx-about-section-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  transform: skewX(-25deg);
  transition: left 0.6s ease;
  pointer-events: none;
  z-index: 3;
}

.nx-about-section-card:hover::before {
  left: 100%;
}

/* 粒子浮动效果 */
.nx-about-section-card::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  top: 20%;
  right: 15%;
  box-shadow: 30px 40px 0 rgba(255, 255, 255, 0.2),
    -20px 60px 0 rgba(255, 255, 255, 0.15),
    50px 100px 0 rgba(255, 255, 255, 0.1);
  animation: particleFloat 8s ease-in-out infinite;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.nx-about-section-card:hover::after {
  opacity: 1;
}

.nx-about-section-card:nth-child(1) {
  background: linear-gradient(180deg, #1e88e5 0%, #1565c0 100%);
}

/* 图片卡片1移除背景色 */
.nx-about-image-card.nx-about-section-1 {
  background: transparent !important;
}

.nx-about-image-card.nx-about-section-1:hover {
  background: transparent !important;
}

.nx-about-section-card:nth-child(1):hover {
  background: linear-gradient(180deg, #2196f3 0%, #1976d2 100%);
}

.nx-about-section-card:nth-child(1) .nx-about-section-text {
  padding-top: 0;
}

.nx-about-section-card:nth-child(2) {
  background: linear-gradient(180deg, #3949ab 0%, #283593 100%);
}

.nx-about-section-card:nth-child(2):hover {
  background: linear-gradient(180deg, #3f51b5 0%, #303f9f 100%);
}

.nx-about-section-card:nth-child(3) {
  background: linear-gradient(180deg, #039be5 0%, #0277bd 100%);
}

/* 图片卡片3移除背景色 */
.nx-about-image-card.nx-about-section-3 {
  background: transparent !important;
}

.nx-about-image-card.nx-about-section-3:hover {
  background: transparent !important;
}

.nx-about-section-card:nth-child(3):hover {
  background: linear-gradient(180deg, #03a9f4 0%, #039be5 100%);
}

.nx-about-section-card:nth-child(4) {
  background: linear-gradient(180deg, #37474f 0%, #1a237e 100%);
}

.nx-about-section-card:nth-child(4):hover {
  background: linear-gradient(180deg, #455a64 0%, #283593 100%);
}

.nx-about-section-card:hover {
  flex: 1.1;
  transform: translateZ(20px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 0 0 60px rgba(59, 130, 246, 0.3),
    inset 0 0 30px rgba(255, 255, 255, 0.1);
}

.nx-about-section-content {
  position: relative;
  z-index: 2;
}

.nx-about-section-text {
  font-size: 15px;
  line-height: 1.9;
  color: #fff;
  margin: 0;
  font-weight: 400;
  text-align: justify;
  white-space: pre-line;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  text-indent: 2em;
  position: relative;
}

/* 文字逐行出现效果 */
.nx-about-section-card:hover .nx-about-section-text {
  animation: textReveal 0.8s ease forwards;
}

/* 图片卡片样式 - 图片直接填满卡片 */
.nx-about-image-card img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}

.nx-about-image-card:hover img {
  transform: scale(1.05);
  filter: brightness(1.05) contrast(1.05);
}

.nx-about-image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    transparent 100%
  );
  padding: 40px 25px 25px;
  transition: all 0.4s ease;
}

.nx-about-image-card:hover .nx-about-image-overlay {
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    transparent 100%
  );
}

.nx-about-image-label {
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  position: relative;
  padding-left: 15px;
}

.nx-about-image-label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: var(--nx-cyan);
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(6, 182, 212, 0.6);
}

.nx-about-image-card:hover .nx-about-image-label {
  transform: translateY(-5px);
  transition: transform 0.4s ease;
}

/* 图片卡片的科技感扫描线 */
.nx-about-image-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transform: skewX(-25deg);
  transition: left 0.8s ease;
  pointer-events: none;
  z-index: 10;
}

.nx-about-image-card:hover::after {
  left: 100%;
}

/* 图片卡片悬停效果 */
.nx-about-image-card:hover {
  transform: translateZ(20px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4), 0 0 80px rgba(59, 130, 246, 0.4),
    inset 0 0 40px rgba(255, 255, 255, 0.15);
}

/* 图片卡片不显示数字编号 */
.nx-about-image-card::before {
  display: none;
}

/* 图片卡片完全撑满，无任何留白 - 彻底重置所有格式 */
.nx-about-image-card {
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  display: block !important;
  position: relative !important;
  background: transparent !important;
  height: 100% !important;
  width: 100% !important;
}

.nx-about-image-card img {
  display: block !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 图片卡片清空所有伪元素 */
.nx-about-image-card::before,
.nx-about-image-card::after {
  display: none !important;
  content: none !important;
}

/* 公司动态部分 */
.nx-news-section {
  position: relative;
  padding: 80px 40px;
  background: transparent;
  overflow: hidden;
}

.nx-news-section::before {
  display: none;
}

.nx-news-section::after {
  display: none;
}

.nx-news-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.nx-news-header {
  text-align: center;
  margin-bottom: 50px;
}

.nx-news-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
}

.nx-news-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15),
    0 0 60px rgba(59, 130, 246, 0.1);
  position: relative;
  display: inline-block;
}

.nx-news-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
  animation: titleGlow 2s ease-in-out infinite;
}

.nx-news-desc {
  font-size: 17px;
  color: #546e7a;
  max-width: 700px;
  margin: 0 auto;
}

.nx-news-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.nx-news-item {
  display: flex;
  align-items: center;
  padding: 28px 35px;
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 247, 255, 0.9) 100%);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(25, 118, 210, 0.15);
  border-left: 3px solid transparent;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  gap: 24px;
  cursor: pointer;
  overflow: hidden;
  transform-style: preserve-3d;
  box-shadow:
    0 4px 20px rgba(25, 118, 210, 0.08),
    0 0 0 1px rgba(25, 118, 210, 0.03) inset;
}

/* 科技感光效 */
.nx-news-item::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 0% 50%, rgba(25, 118, 210, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 100% 50%, rgba(66, 165, 245, 0.05) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.nx-news-item:hover::before {
  opacity: 1;
}

/* 数据流动效果 */
.nx-news-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    #1976d2,
    #42a5f5,
    transparent
  );
  background-size: 200% 100%;
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.nx-news-item:hover::after {
  transform: translateX(100%);
  animation: dataFlow 1.5s linear infinite;
}

.nx-news-item:not(:last-child) {
  margin-bottom: 20px;
}

.nx-news-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 0;
  background: linear-gradient(
    180deg,
    var(--nx-blue-primary) 0%,
    var(--nx-cyan) 100%
  );
  border-radius: 0 4px 4px 0;
  transition: height 0.3s ease;
}

.nx-news-item:hover {
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 1) 0%, rgba(240, 247, 255, 0.98) 100%);
  border-color: rgba(25, 118, 210, 0.3);
  border-left-color: #1976d2;
  box-shadow:
    0 12px 40px rgba(25, 118, 210, 0.15),
    0 0 50px rgba(25, 118, 210, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transform: translateX(10px) translateY(-3px);
}

.nx-news-item:hover::before {
  height: 60%;
}

.nx-news-item:hover .nx-news-arrow {
  transform: translateX(4px);
  color: #1976d2;
}

.nx-news-arrow {
  width: 24px;
  height: 24px;
  color: #90a4ae;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nx-news-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  height: 70px;
  background: linear-gradient(
    135deg,
    #1976d2 0%,
    #42a5f5 100%
  );
  background-size: 200% 200%;
  border-radius: 12px;
  color: #fff;
  flex-shrink: 0;
  box-shadow:
    0 4px 15px rgba(25, 118, 210, 0.3),
    inset 0 0 20px rgba(255, 255, 255, 0.15);
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  animation: gradientFlow 4s ease infinite;
}

/* 日期卡片的扫描线效果 */
.nx-news-date::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 40%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 60%
  );
  transform: rotate(45deg) translateY(-100%);
  transition: transform 0.6s ease;
}

.nx-news-item:hover .nx-news-date::before {
  transform: rotate(45deg) translateY(100%);
}

/* 日期卡片的脉冲光晕 */
.nx-news-date::after {
  content: "";
  position: absolute;
  inset: -2px;
  background: linear-gradient(
    135deg,
    #1976d2,
    #42a5f5,
    #1976d2
  );
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.4s ease;
  filter: blur(8px);
}

.nx-news-item:hover .nx-news-date::after {
  opacity: 0.7;
  animation: datePulse 2s ease-in-out infinite;
}

.nx-news-year {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.nx-news-md {
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}

.nx-news-info {
  flex: 1;
  min-width: 0;
}

.nx-news-item-title {
  font-size: 18px;
  font-weight: 700;
  color: #0a1628;
  margin-bottom: 8px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 16px;
}

/* 标题前的装饰 */
.nx-news-item-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.3s ease;
}

.nx-news-item:hover .nx-news-item-title {
  color: #1976d2;
  padding-left: 20px;
}

.nx-news-item:hover .nx-news-item-title::before {
  opacity: 1;
  transform: scale(1);
  left: 2px;
}

.nx-news-text {
  font-size: 14px;
  line-height: 1.6;
  color: #546e7a;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: left;
  transition: all 0.3s ease;
}

.nx-news-item:hover .nx-news-text {
  -webkit-line-clamp: unset;
  max-height: none;
  white-space: normal;
  color: #37474f;
}

.nx-news-item:hover .nx-news-text {
  -webkit-line-clamp: unset;
  max-height: none;
  white-space: normal;
}

/* 查看更多按钮 */
.nx-news-more {
  position: absolute;
  top: 100px;
  right: 0;
  z-index: 10;
}

.nx-news-more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
  border: 1.5px solid rgba(25, 118, 210, 0.2);
  color: #1976d2;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 2px 8px rgba(25, 118, 210, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
}

.nx-news-more-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-color: transparent;
  color: #fff;
  transform: translateX(4px);
  box-shadow:
    0 4px 15px rgba(25, 118, 210, 0.25),
    inset 0 0 0 transparent;
}

.nx-news-more-btn svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.nx-news-more-btn:hover svg {
  transform: translateX(2px);
}

/* 为什么选择文信部分 - 高级科技感 */
.nx-why-section {
  position: relative;
  padding: 80px 40px 80px 40px;
  background: #ffffff;
  overflow: hidden;
}

/* 六边形网格背景 */
.nx-why-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 50% 50%, transparent 0%, transparent 49%, rgba(25, 118, 210, 0.02) 50%, transparent 51%),
    linear-gradient(0deg, rgba(25, 118, 210, 0.015) 1px, transparent 1px),
    linear-gradient(90deg, rgba(25, 118, 210, 0.015) 1px, transparent 1px);
  background-size: 60px 60px, 30px 30px, 30px 30px;
  animation: gridScroll 30s linear infinite;
  pointer-events: none;
}

/* 动态光晕效果 */
.nx-why-section::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background:
    radial-gradient(circle at 20% 30%, rgba(25, 118, 210, 0.03) 0%, transparent 25%),
    radial-gradient(circle at 80% 70%, rgba(66, 165, 245, 0.02) 0%, transparent 25%),
    radial-gradient(circle at 50% 50%, rgba(25, 118, 210, 0.02) 0%, transparent 30%);
  animation: auraRotate 20s linear infinite;
  pointer-events: none;
}

.nx-why-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.nx-why-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
}

/* 标题容器科技边框 */
.nx-why-header::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 50%;
  animation: techRingRotate 10s linear infinite;
  pointer-events: none;
}

.nx-why-header::after {
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  height: 220px;
  border: 1px dashed rgba(139, 92, 246, 0.15);
  border-radius: 50%;
  animation: techRingRotate 15s linear infinite reverse;
  pointer-events: none;
}

.nx-why-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
  position: relative;
  z-index: 2;
}

.nx-why-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15),
    0 0 60px rgba(59, 130, 246, 0.1);
  position: relative;
  display: inline-block;
}

.nx-why-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
  animation: titleGlow 2s ease-in-out infinite;
}

.nx-why-desc {
  font-size: 17px;
  color: #666666;
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.nx-why-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: start;
}

.nx-why-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.nx-why-item {
  padding: 32px 30px 32px 40px;
  background:
    linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid rgba(25, 118, 210, 0.15);
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(25, 118, 210, 0.05) inset;
  will-change: transform, box-shadow;
  overflow: hidden;
  transform-style: preserve-3d;
  perspective: 1000px;
}

/* 内部光效渐变 */
.nx-why-item::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 0% 0%, rgba(0, 212, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 100% 100%, rgba(139, 92, 246, 0.1) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.nx-why-item:hover::after {
  opacity: 1;
}

/* 四角科技装饰 - 左上 */
.nx-why-item .corner-tl {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  border-top: 2px solid #1976d2;
  border-left: 2px solid #1976d2;
  border-radius: 4px 0 0 0;
  opacity: 0.5;
  box-shadow: -2px -2px 8px rgba(25, 118, 210, 0.2);
}

/* 四角科技装饰 - 右下 */
.nx-why-item .corner-br {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  border-bottom: 2px solid #42a5f5;
  border-right: 2px solid #42a5f5;
  border-radius: 0 0 4px 0;
  opacity: 0.5;
  box-shadow: 2px 2px 8px rgba(66, 165, 245, 0.2);
}

/* 顶部发光线 */
.nx-why-item .top-line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #1976d2, #42a5f5, transparent);
  transition: width 0.5s ease;
  box-shadow: 0 0 10px rgba(25, 118, 210, 0.3);
}

.nx-why-item > *:first-child {
  position: relative;
  z-index: 2;
}

.nx-why-item:hover {
  transform: translateY(-6px) translateZ(10px);
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.12),
    0 0 30px rgba(25, 118, 210, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-color: rgba(25, 118, 210, 0.3);
}

.nx-why-item:hover .top-line {
  width: 80%;
}

.nx-why-item-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
  padding-left: 16px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* 标题前的图标装饰 */
.nx-why-item-title::before {
  content: "";
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: inline-block;
  box-shadow: 0 0 10px rgba(25, 118, 210, 0.4);
  animation: iconRotate 10s linear infinite;
}

.nx-why-text {
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
  padding-left: 16px;
  margin: 0;
  text-align: left;
  text-indent: 2em;
}

/* 响应式设计 */
/* 高级科技感动画 */
@keyframes gridScroll {
  0% {
    background-position: 0 0, 0 0, 0 0;
  }
  100% {
    background-position: 60px 60px, 30px 30px, 30px 30px;
  }
}

@keyframes auraRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes techRingRotate {
  0% {
    transform: translateX(-50%) rotate(0deg);
  }
  100% {
    transform: translateX(-50%) rotate(360deg);
  }
}

@keyframes lineGlow {
  0%, 100% {
    opacity: 0.6;
    width: 80px;
  }
  50% {
    opacity: 1;
    width: 120px;
  }
}

@keyframes scanLine {
  0% {
    top: -100%;
  }
  100% {
    top: 200%;
  }
}

@keyframes glowPulse {
  0%, 100% {
    opacity: 0.6;
    box-shadow:
      0 0 10px rgba(0, 212, 255, 0.8),
      0 0 20px rgba(139, 92, 246, 0.5);
  }
  50% {
    opacity: 1;
    box-shadow:
      0 0 15px rgba(0, 212, 255, 1),
      0 0 30px rgba(139, 92, 246, 0.8);
  }
}

@keyframes dotPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.8;
  }
}

@keyframes iconRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  .nx-news-item {
    padding: 28px 30px;
    gap: 20px;
  }

  .nx-news-date {
    min-width: 60px;
    height: 60px;
  }

  .nx-news-year {
    font-size: 18px;
  }

  .nx-news-md {
    font-size: 11px;
  }

  .nx-news-item-title {
    font-size: 17px;
  }

  .nx-news-text {
    font-size: 13px;
  }

  .nx-about-content-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .nx-about-section-card {
    padding: 35px 28px;
    min-height: 350px;
  }

  .nx-about-section-text {
    font-size: 14px;
    line-height: 1.8;
  }

  .nx-why-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .nx-news-section {
    padding: 50px 20px;
  }

  /* 移动端查看更多按钮改小 */
  .nx-news-more-btn {
    padding: 8px 14px;
  }

  .nx-news-more-btn svg {
    width: 16px;
    height: 16px;
  }

  .nx-news-content {
    gap: 0;
  }

  .nx-news-item {
    flex-direction: row;
    align-items: center;
    padding: 16px 20px;
    gap: 12px;
  }

  .nx-news-item:not(:last-child) {
    margin-bottom: 12px;
  }

  .nx-news-item:hover {
    transform: translateX(4px);
  }

  .nx-news-date {
    min-width: 45px;
    height: 45px;
    flex-shrink: 0;
  }

  .nx-news-year {
    font-size: 14px;
  }

  .nx-news-md {
    font-size: 9px;
  }

  .nx-news-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nx-news-item-title {
    font-size: 14px;
    margin-bottom: 0;
    -webkit-line-clamp: 1;
    padding-left: 0;
  }

  .nx-news-item-title::before {
    display: none;
  }

  .nx-news-item:hover .nx-news-item-title {
    padding-left: 0;
  }

  .nx-news-text {
    font-size: 12px;
    -webkit-line-clamp: 1;
  }

  .nx-news-arrow {
    display: none;
  }

  .nx-about-content-grid {
    grid-template-columns: 1fr;
  }

  .nx-about-section-card {
    padding: 10px 25px;
    min-height: auto;
    justify-content: center;
  }
  .nx-about-section-text {
    font-size: 16px;
    line-height: 1.8;
  }

  .nx-about-intro {
    padding: 100px 0;
  }

  .nx-about-container {
    padding: 0 20px;
  }

  .nx-why-section {
    padding: 60px 20px;
    background: #ffffff;
  }

  .nx-why-content {
    gap: 20px;
  }

  .nx-why-column {
    gap: 16px;
  }

  .nx-why-section {
    padding: 60px 20px;
    background: #ffffff;
  }

  .nx-why-content {
    gap: 20px;
  }

  .nx-why-column {
    gap: 16px;
  }

  .nx-why-item {
    padding: 24px 24px 24px 32px;
  }

  .nx-why-item-title {
    font-size: 16px;
    margin-bottom: 10px;
    padding-left: 12px;
  }

  .nx-why-item-title::before {
    width: 20px;
    height: 20px;
  }

  .nx-why-text {
    font-size: 13px;
    line-height: 1.7;
    padding-left: 12px;
  }

  .nx-why-subtitle {
    font-size: 1rem;
    letter-spacing: 0.2rem;
  }
}

/* 科技感关键帧动画 */
@keyframes particleFloat {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  25% {
    transform: translate(10px, -20px) scale(1.1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-5px, -40px) scale(0.9);
    opacity: 0.4;
  }
  75% {
    transform: translate(15px, -20px) scale(1.05);
    opacity: 0.5;
  }
}

@keyframes dataFlow {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.02);
  }
}

@keyframes shimmer {
  0%,
  100% {
    opacity: 0.5;
    transform: scaleX(1);
  }
  50% {
    opacity: 1;
    transform: scaleX(1.1);
  }
}

@keyframes gradientFlow {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(20px, -20px);
  }
}

/* 入场动画类 */
.nx-animate-on-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.nx-animate-on-scroll.nx-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 网格背景动画 */
.nx-grid-bg {
  position: relative;
}

.nx-grid-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(
      rgba(21, 101, 192, 0.03) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(21, 101, 192, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
  pointer-events: none;
}

@keyframes gridMove {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

/* 标题光效动画 */
@keyframes titleGlow {
  0%,
  100% {
    width: 60px;
    opacity: 0.6;
  }
  50% {
    width: 120px;
    opacity: 1;
  }
}

/* 文字揭示动画 */
@keyframes textReveal {
  from {
    opacity: 0.7;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 日期卡片脉冲动画 */
@keyframes datePulse {
  0%,
  100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
</style>
